import {Entity} from '@s-ui/domain'

export default class PurchaseDetailsEntity extends Entity {
  /**
   * @param {Object} data
   * @param {String} data.pspReference
   * @param {Object} data.action
   * */
}
